import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const userManagementApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // Get all users
    getAllUsers: builder.query({
      query: () => ({
        url: "qwikITUser/",
        method: "GET",
      }),
      providesTags: ["users"],
      transformResponse: response => response.reverse(),
    }),

    // Get a single user by ID
    getUser: builder.query({
      query: id => ({
        url: `qwikITUser/${id}/`,
        method: "GET",
      }),
      providesTags: ["users"],
      transformResponse: response => response,
    }),

    // Create a new user
    createUser: builder.mutation({
      query: data => ({
        url: "qwikITUser/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["users"],
      transformResponse: response => {
        toast.success("User created successfully");
        return response;
      },
    }),

    // // Update user
    // updateUser: builder.mutation({
    //   query: ({ id, formData }) => ({
    //     url: `qwikITUser/${id}/`,
    //     method: "PATCH",
    //     body: formData,
    //   }),
    //   invalidatesTags: ["users"],
    //   transformResponse: response => {
    //     toast.success("User updated successfully");
    //     return response;
    //   },
    // }),

    updateUser: builder.mutation({
      query: ({ id, formData }) => ({
        url: `qwikITUser/${id}/`,
        method: "PATCH",
        body: formData,
        // VERY IMPORTANT: prevents RTK Query from setting application/json
        headers: {
          // Let browser set correct multipart boundary
        },
      }),
      invalidatesTags: ["users"],
      transformResponse: response => {
        toast.success("User updated successfully");
        return response;
      },
    }),



    // Delete user
    deleteUser: builder.mutation({
      query: id => ({
        url: `qwikITUser/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["users"],
      transformResponse: response => {
        toast.success("User deleted successfully");
        return response;
      },
    }),
  }),
});

export const {
  useGetAllUsersQuery,
  useGetUserQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = userManagementApi;